import { useEffect, useState } from 'react';
import { Button, Container, Divider, Grid, Paper, Stack, Typography, Box, Dialog } from '@mui/material';
import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, SelectTag } from '../../../../../../src/components';
import {  request, toast } from '../../../../../../src/utils';
import { DietManagementTable } from '../Utils/DietManagementTable';
import { DietManagementDetailForm } from './DietManagementDetailForm';


function formatDate(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}
const DETAIL_HEADER = [
  {
    header: 'Patient Name',
    accessor: (row) => `${row.patient.name_suffix} ${row.patient.first_name} ${row.patient.last_name}`
  },
  {
    header: 'UHID No',
    accessor: 'uhid'
  },
  {
    header: 'Adm No.',
    accessor: 'ipd_no'
  },
  {
    header: 'Doctor Name',
    accessor: 'consultant_detail.doctor.name'
  },
  {
    header: 'Sponsor',
    accessor: 'patient.sponsor.name'
  },
  {
    header: 'Ward',
    accessor: 'consultant_detail.room.ward.name'
  },
  {
    header: 'Room No.',
    accessor: 'consultant_detail.room.room_no'
  },
  {
    header: 'Bed',
    accessor: 'consultant_detail.bed_no'
  },
  {
    header: 'Adm Date',
    accessor: (row) => formatDate(row?.date)
  },
  {
    header: 'Nurse Station',
    accessor: 'consultant_detail.room.nurse_station.name'
  },
];

const TODAY_IPD_DETAIL_HEADER = [
  {
    header: 'Patient Name',
    accessor: (row) => `${row.patient[0]?.name_suffix} ${row.patient[0]?.first_name} ${row.patient[0]?.last_name}`
  },
  {
    header: 'Diet Type',
    accessor: "diet_type"
  },
  {
    header: 'Diet Details',
    accessor: "diet_detail"
  },
  {
    header: 'Date',
    accessor: (row)=> formatDate(row?.date)
  },
  {
    header: 'Time',
    accessor: 'time'
  }
];

const initialDietsDataObj = {
  data: [],
  loading: false
};

export const DietManagementForm= () => {
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [todayIpdList, setTodayIpdList] = useState([]);
  const [currentAction, setCurrentAction] = useState();
  const [addDetailsDialogue,setAddDetailsDialogOpen] = useState(false)
  const[selectedRows,setSelectedRows] = useState([])
  const [dietDetails,setDietDetails] = useState([])
  

  const methods = useForm({
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0],
      to_date: new Date().toISOString().split('T')[0]
    },
    mode: 'all'
  });
  const { handleSubmit, setValue, reset, watch } = methods;

  const searchIPDDetails = async () => {
    setLoading(true);
    const response = await request('/indoor-registeration-status', {
      method: 'GET'
    });
    if (response?.success) {
      if (!response?.data || response.data.length === 0) {
        toast('No IPD found', { variant: 'warning' });
      } else {
        setDetailList(response?.data);
      }
    } 
    setLoading(false);
  };

  useEffect(() => {
    searchIPDDetails();
  }, []);

  const handleAddDiet=()=>{
    setAddDetailsDialogOpen(true)
  }

  const isSelected = (row, field) => {
    return selectedRows.length > 0 && selectedRows[0]._id === row._id;
  };
  
  const handleRowSelect = (row, field) => {
    setDietDetails([]);
    setSelectedRows((prevSelectedRows) => {
      if (prevSelectedRows.length === 0 || prevSelectedRows[0]._id !== row._id) {
        return [{ ...row, [field]: true }]; 
      } else {
        return []; 
      }
    });
  };
  
  const searchIPDRegisterationDetails = async (ipdNo) => {
    setLoading(true);
    const response = await request('/diet-management-detail', {
      method: 'GET',
      params: ipdNo
    });
    if (response?.success) {
      const { data } = response;
      if (!data) {
        toast('No patient found', { variant: 'warning' });
      } else {
        setDietDetails(response?.data);
      }
    } 
    setLoading(false);
  };

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          boxSizing: 'border-box'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: '100vw',
            boxSizing: 'border-box',
            minWidth: '100%'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
               Diet Management
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                {/* <Button variant="contained">Refresh</Button> */}
                {/* <Button variant="contained">Excel</Button> */}
                {/* <Button variant="contained">PDF</Button> */}
                <Button variant="contained">Default Exhaust</Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <DietManagementTable
                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                    data={detailList}
                    columns={DETAIL_HEADER}
                    size="small"
                    showAddDetails={true}
                    onClickEditRow={handleAddDiet}
                    showOk={true}
                    isSelected={isSelected}
                    handleRowSelect={handleRowSelect}
                    selectedRows={selectedRows}
                    onRowClick={(row)=>searchIPDRegisterationDetails(row?.ipd_no)}
                  />
                </Grid>

                <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                  <Typography sx={{ fontWeight: 700, fontSize: '1.4rem' }}>Patient Diet History</Typography>
                  <Divider />
                  <Table
                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                    data={dietDetails || []}
                    columns={TODAY_IPD_DETAIL_HEADER}
                    size="small"
                  />
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
        <Dialog
        open={addDetailsDialogue}
        onClose={() => setAddDetailsDialogOpen(false)}
        PaperProps={{ sx: { width: '50%', height: '50vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <DietManagementDetailForm
          onClose={() => setAddDetailsDialogOpen(false)}
          ipdNo={selectedRows[0]?.ipd_no}
          uhid={selectedRows[0]?.uhid}
          searchIPDRegisterationDetails={searchIPDRegisterationDetails}
        />
      </Dialog>
      </Paper>
    </>
  );
};
